import React from 'react';

const LogoWorldox = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#1E3A5F"/>
    <path d="M12 14H24L28 34H20L18 26H14L12 14Z" fill="white"/>
    <path d="M26 14H36L34 22H28L26 14Z" fill="white"/>
  </svg>
);

export default LogoWorldox;
